__turbopack_context__.v({
  "backdrop": "Modal-module-scss-module__yswRDq__backdrop",
  "bottom": "Modal-module-scss-module__yswRDq__bottom",
  "center": "Modal-module-scss-module__yswRDq__center",
  "fadeIn": "Modal-module-scss-module__yswRDq__fadeIn",
  "fadeOut": "Modal-module-scss-module__yswRDq__fadeOut",
  "full": "Modal-module-scss-module__yswRDq__full",
  "modal": "Modal-module-scss-module__yswRDq__modal",
  "position_wrapper": "Modal-module-scss-module__yswRDq__position_wrapper",
  "scaleIn": "Modal-module-scss-module__yswRDq__scaleIn",
  "scaleOut": "Modal-module-scss-module__yswRDq__scaleOut",
  "top": "Modal-module-scss-module__yswRDq__top",
});
